/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_WonInputs */

const th_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช`)
};

const en_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W`)
};

const ja_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`勝`)
};

const zh_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`胜`)
};

const es_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G`)
};

const pt_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V`)
};

const id_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const fr_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V`)
};

const tl_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P`)
};

const vi_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

const ko_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승`)
};

const de_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

const ru_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В`)
};

const tr_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G`)
};

const it_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V`)
};

const pl_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W`)
};

const uk_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В`)
};

const hi_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जी`)
};

const ar_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ف`)
};

const ms_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M`)
};

const bn_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জি`)
};

const zh_tw2_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`勝`)
};

const zh_hk2_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`勝`)
};

const ur_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ج`)
};

const fa_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بر`)
};

const sw_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U`)
};

const nl_col_won = /** @type {(inputs: Col_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W`)
};

/**
* | output |
* | --- |
* | "W" |
*
* @param {Col_WonInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const col_won = /** @type {((inputs?: Col_WonInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_WonInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_col_won(inputs)
	if (locale === "ja") return ja_col_won(inputs)
	if (locale === "zh") return zh_col_won(inputs)
	if (locale === "es") return es_col_won(inputs)
	if (locale === "pt") return pt_col_won(inputs)
	if (locale === "id") return id_col_won(inputs)
	if (locale === "fr") return fr_col_won(inputs)
	if (locale === "tl") return tl_col_won(inputs)
	if (locale === "vi") return vi_col_won(inputs)
	if (locale === "ko") return ko_col_won(inputs)
	if (locale === "de") return de_col_won(inputs)
	if (locale === "ru") return ru_col_won(inputs)
	if (locale === "tr") return tr_col_won(inputs)
	if (locale === "it") return it_col_won(inputs)
	if (locale === "pl") return pl_col_won(inputs)
	if (locale === "uk") return uk_col_won(inputs)
	if (locale === "hi") return hi_col_won(inputs)
	if (locale === "ar") return ar_col_won(inputs)
	if (locale === "ms") return ms_col_won(inputs)
	if (locale === "bn") return bn_col_won(inputs)
	if (locale === "zh-TW") return zh_tw2_col_won(inputs)
	if (locale === "zh-HK") return zh_hk2_col_won(inputs)
	if (locale === "ur") return ur_col_won(inputs)
	if (locale === "fa") return fa_col_won(inputs)
	if (locale === "sw") return sw_col_won(inputs)
	if (locale === "nl") return nl_col_won(inputs)
	return en_col_won(inputs)
});